import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import MuiTabs, { tabsClasses } from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

import KeyboardAccessible from 'components/KeyboardAccessible'

import { color } from 'styles/colors'

type Props = {
  selectedTabIndex: number
  updateActiveTabCallback: (newValue: number) => void
  scrollToDivCallback: (link: object) => void
  tabs: Array<{
    label: string
    to: string
  }>
}

const SubNavbar = ({ selectedTabIndex, tabs, updateActiveTabCallback, scrollToDivCallback }: Props) => {
  const [activeTab, setActiveTab] = useState(selectedTabIndex)

  useEffect(() => {
    setActiveTab(selectedTabIndex)
  }, [selectedTabIndex])

  const onTabClick = (event, tab) => {
    scrollToDivCallback(tab)

    const parent = event.currentTarget.parentNode
    const childrenArray = Array.from(parent.children)
    const newValue = childrenArray.indexOf(event.currentTarget)
    setActiveTab(newValue)
    updateActiveTabCallback(newValue)
  }

  return (
    <S.Container>
      <S.Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={activeTab}
        aria-label="device top navbar"
      >
        {tabs.map((tab, index) => (
          <KeyboardAccessible key={tab.to} onClick={(event) => onTabClick(event, tab)}>
            <S.Tab disableRipple label={tab.label} selected={activeTab === index} tabIndex={-1} />
          </KeyboardAccessible>
        ))}
      </S.Tabs>
    </S.Container>
  )
}

export default SubNavbar

const S = {
  Container: styled.div`
    position: sticky;
    z-index: 99;
    top: 0;
    display: grid;
    background-color: ${color('activeTabBackground')};
  `,
  Tabs: styled(MuiTabs)({
    [`& .${tabsClasses.flexContainer}`]: {
      gap: '45px',
      maxWidth: '1400px'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: `${color('activeTabHighlight')};`,
      height: '4px',
      bottom: '10px'
    },

    [`& .${tabsClasses.scrollButtons}`]: {
      alignSelf: 'center',
      width: '30px',

      '&.Mui-disabled': {
        opacity: 0.3,
        visibility: 'hidden'
      },

      '& svg': {
        fontSize: '30px',
        background: color('paneBackground'),
        borderRadius: '50%'
      }
    }
  }),
  Tab: styled(Tab)<{ selected: boolean }>`
    font-family: Inter, sans-serif;
    text-transform: none;
    color: ${color('subNavText')};
    padding: 0 7px;
    font-size: 14px;
    letter-spacing: 0;
    width: max-content;
    min-width: auto;
    ${({ selected }) => selected && `color: ${color('activeTabHighlight')};`}
    &:focus { outline: none; }
  `
}
